import './requests'
import './features/supportDataLoading.js'
import './features/supportPaginators.js'
import './features/supportPreserveScroll.js'
import './features/supportWireIntersect.js'
import './features/supportWireIsland.js'
import './features/supportJsModules.js'
import './interceptors'